import { getData, postData } from "./apiUtils";
import * as CONFIG from '../utils/config'


export function saveTemplateData(data) {
    return postData(CONFIG.SAVE_TEMPLATE_DATA_URL(), data);
}

export function loadTemplateData(moduleId) {
    return getData(CONFIG.LOAD_TEMPLATE_DATA_URL() + moduleId);
}
